import Account from './Account/Account';

export default Account;